/**
 * Settings menu content.
 *
 * Complete menu content for settings: theme picker and sign out.
 * Includes the Menu.Content wrapper.
 */

import { logOut } from "@animus/iconic-svg/icons/log-out";
import { Icon, Menu } from "@animus/primaris";

import { ThemePickerSubmenu } from "../theme-picker-submenu/theme-picker-submenu";

interface SettingsMenuContentProps {
  /** Callback for sign out action (if provided, shows sign out option) */
  onSignOut?: () => void;
}

export function SettingsMenuContent({ onSignOut }: SettingsMenuContentProps) {
  return (
    <Menu.Content>
      <ThemePickerSubmenu />
      {onSignOut && (
        <>
          <Menu.Divider />
          <Menu.MenuItem destructive onSelect={onSignOut}>
            <Icon size="xs" svg={logOut} />
            <span>Sign Out</span>
          </Menu.MenuItem>
        </>
      )}
    </Menu.Content>
  );
}
